module.exports = __webpack_public_path__ + "img/image-04.ee4d8da1.jpeg";